import { type ComponentType, useCallback } from 'react';
import cn from 'classnames';
import { type ColumnCellTemplateProps } from '@adv-frontend/grid';
import { getCellDataTestId } from './getCellDataTestId';
import {
    type AdditionalCellProps,
    type BaseRowData,
    type ExtendCellTemplateBaseProps,
    type ParentAndChildRowsProps,
} from './types';
import styles from './ExtendGridCelWithSubRowsHoc.module.css';

export function renderExtendGridCellWithSubRows<
    CellRowData extends BaseRowData & ParentAndChildRowsProps,
    GridRowData extends BaseRowData = CellRowData,
>(
    Cell: ComponentType<ExtendCellTemplateBaseProps<CellRowData>>,
    additionalProps: AdditionalCellProps<CellRowData> = {}
) {
    const { onClickRow, ...otherAdditionalProps } = additionalProps;

    return function RenderCellWithDataTestIdHoc(props: ColumnCellTemplateProps<GridRowData>) {
        const cellProps = props as unknown as ColumnCellTemplateProps<CellRowData>;
        const handleClick = useCallback(() => onClickRow?.(cellProps.data), [cellProps.data]);

        const clickableProps = cellProps.data.isSubRow
            ? {
                  onClick: handleClick,
                  className: cn({
                      [styles.clickable]: Boolean(onClickRow),
                  }),
              }
            : {};

        return (
            <Cell
                data-testid={getCellDataTestId(cellProps)}
                {...cellProps}
                {...clickableProps}
                {...otherAdditionalProps}
            />
        );
    };
}
